import { GetStaticPaths, GetStaticProps } from 'next';
import { PricingPage } from '@/pages/Pricing';
import { paymentModel } from '@/entities/payment';
import { deviceType, timeInSeconds } from '@/shared/constants';
import { getPaths, parseSSGParams } from '@/shared/helpers';
import { checkRequestErrors } from '@/shared/utils';

export const getStaticProps: GetStaticProps = async (context) => {
  const { device } = parseSSGParams(context.params);

  const isValidPath = Object.values(deviceType).includes(device);
  if (!isValidPath) {
    return {
      notFound: true,
    };
  }

  const { tariffs, ssrCache } = await paymentModel.getTariffsList();

  const { revalidate, urqlState } = checkRequestErrors(ssrCache.extractData(), timeInSeconds.WEEK);

  return {
    props: {
      tariffs,
      urqlState,
    },
    revalidate,
  };
};

export const getStaticPaths: GetStaticPaths = async (context) => {
  return {
    paths: getPaths(),
    fallback: 'blocking',
  };
};

export default PricingPage;
